import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getOpBase } from "../../services/user.service";
import EventBus from "../../common/EventBus";
import Parameters from "./last-price";
import ParametersFM from "./fast-market";
import RunParametes from "./run-parameters";
import EditParameters from "./edit-parameters";

const BoardParams = () => {
  const [content, setContent] = useState({});
  let { parpage } = useParams();

  useEffect(() => {
    getOpBase().then(response => {
      setContent(response.data);
    }, error => {
      setContent((error.response && error.response.data && error.response.data.message) || error.message || error.toString());

      if (error.response && error.response.status === 401) {
        EventBus.dispatch("logout");
      }
    });
  }, []);

  return <div className="flex items-center justify-center min-w-full grow">
    {content.comp === "瓦斯" ?
      (parpage === 'calc' ?
        <RunParametes /> :
        (parpage === 'edit' ?
          <EditParameters /> :
          (parpage === 'fastmarket' ?
            <ParametersFM /> :
            <Parameters />
          )
        )
      )
      : null}
  </div>;
};

export default BoardParams;